import ReplacementsIcon from '../../../../assets/images/firmware-mock/device-replacement.svg';
import ReplacementsDarkIcon from '../../../../assets/images/firmware-mock/device-replacement-dark.svg';
import SoftwareUpdateCompleteSlide1 from '../../../../assets/images/firmware-mock/software-update-complete/PROTECTED-software-update-complete-slide-1.webp';
import SoftwareUpdateCompleteSlide2 from '../../../../assets/images/firmware-mock/software-update-complete/PROTECTED-software-update-complete-slide-2.webp';
import SoftwareUpdateCompleteSlide3 from '../../../../assets/images/firmware-mock/software-update-complete/PROTECTED-software-update-complete-slide-3.webp';
import SoftwareUpdateCompleteSlide4 from '../../../../assets/images/firmware-mock/software-update-complete/PROTECTED-software-update-complete-slide-4.webp';
import TasteIcon from '../../../../assets/images/firmware-mock/taste-exploration.svg';
import TasteDarkIcon from '../../../../assets/images/firmware-mock/taste-exploration-dark.svg';
import TouchScreenIcon from '../../../../assets/images/firmware-mock/touch-screen.svg';
import TouchScreenDarkIcon from '../../../../assets/images/firmware-mock/touch-screen-dark.svg';
import {strCode} from '../../../../consts/strCode';
import {t} from '../../../../services/localization/localizationService';

const getFirmwareUpdateCompleteDefaultFeature = () => [
    {
        title: t(strCode.FWU_SOFTWARE_UPDATE_COMPLETE_TITLE),
        description: t(strCode.FWU_SOFTWARE_UPDATE_COMPLETE_DESCRIPTION),
        mediaSrc: SoftwareUpdateCompleteSlide1,
    },
];

const getFirmwareUpdateListWithIconReleaseNotes = (isDarkMode) => [
    {
        title: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_1_ITEM_TITLE),
        description: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_1_ITEM_DESCRIPTION),
        mediaSrc: isDarkMode ? TasteDarkIcon : TasteIcon,
    },
    {
        title: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_2_ITEM_TITLE),
        description: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_2_ITEM_DESCRIPTION),
        mediaSrc: isDarkMode ? ReplacementsDarkIcon : ReplacementsIcon,
    },
    {
        title: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_3_ITEM_TITLE),
        description: t(strCode.FWU_LIST_WITH_ICONS_RELEASE_NOTES_3_ITEM_DESCRIPTION),
        mediaSrc: isDarkMode ? TouchScreenDarkIcon : TouchScreenIcon,
    },
];

const getFirmwareUpdateReleaseNotesMock = () => [
    {
        version: '12.1.0',
        type: 'WALKTHROUGH',
        localizations: [
            {
                languageCode: 'EN',
                summary: t(strCode.FWU_MOCK_RELEASE_NOTES_SUMMARY),
                features: [
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_1_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_1_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide2,
                    },
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_2_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_2_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide3,
                    },
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_3_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_3_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide4,
                    },
                ],
            },
            {
                languageCode: 'CS',
                summary: t(strCode.FWU_MOCK_RELEASE_NOTES_SUMMARY),
                features: [
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_1_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_1_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide2,
                    },
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_2_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_2_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide3,
                    },
                    {
                        title: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_3_TITLE),
                        description: t(strCode.FWU_MOCK_RELEASE_NOTES_FEATURE_3_DESCRIPTION),
                        mediaSrc: SoftwareUpdateCompleteSlide4,
                    },
                ],
            },
        ],
    },
];

export default {
    getFirmwareUpdateListWithIconReleaseNotes,
    getFirmwareUpdateCompleteDefaultFeature,
    getFirmwareUpdateReleaseNotesMock,
};
